//interfaces
import { IUserProfileImages } from "../../../../interfaces/image/image";

// helpers
import { getImageAsset } from "../../../../helpers/Images";



const UserProfileImages = ({imageUrl, isSingleProfile = false, imageCap, plusUserPlaceholder, isDoubleIconOffset} :IUserProfileImages) => {   
  const imageLimit = (isDoubleIconOffset && imageUrl.length > 1 && !isSingleProfile) ? 2 : imageCap;
  const imagesToDisplay = imageUrl?.slice(0, imageLimit) || [];

  return (
    <div className={`user-profile-image-wrapper ${isSingleProfile ? 'single-item' : ''} ${!isSingleProfile && isDoubleIconOffset ? 'double-icon-offset' : ''}`} aria-hidden="true">
        {imagesToDisplay.map((url, index) => (
            <img 
              key={index} 
              src={getImageAsset(140, url)} 
              className={`profile-image-icon profile-${index}`} 
              alt="" 
              data-testid={`profile-image-${index}`}
            />
        ))}

        {plusUserPlaceholder && 
            <span className="plus-users"> +{plusUserPlaceholder}</span>
        }
    </div>
  );
}
export default UserProfileImages